import { AscendErrorUtils } from "@ascend-ltd/accounts-core";
import * as Sentry from "@sentry/nextjs";
import { matchEnvironment } from "./env-utils";

const reportError = (e: Error | unknown) => {
  matchEnvironment({
    local: (e: Error | unknown) => {
      alert(e);
      console.error(e);
    },
    development: (e: Error | unknown) => {
      alert(e);
      console.error(e);
      Sentry.captureException(e);
    },
    production: (e: Error | unknown) => {
      Sentry.captureException(e);
    },
  })(e);
};

export const reportUnhandledError = (e: Error | unknown) => {
  if (shouldReport(e)) {
    reportError(e);
  }
};

const shouldReport = (e: Error | unknown): boolean => {
  // TODO: filter unreporting error
  if (AscendErrorUtils.isClientError(e)) {
    if (e.errorCode === "auth.unauthorized") {
      return false;
    }
  }
  return true;
};
